import { toast } from 'react-toastify';

export async function fetchWithAuth(input: RequestInfo, init: RequestInit = {}) {
  const token = localStorage.getItem('jwt');

  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}${input}`, {
      ...init,
      headers: {
        'Content-Type': 'application/json',
        ...(init.headers || {}),
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "monkey"
      },
    });

    if (response.status === 401) {
      localStorage.removeItem('jwt');
      window.location.href = '/login';
      // Return here: the navigation above is async, so without it we fall through
      // and toast a redundant "An error occurred" on top of the redirect.
      return response;
    }

    if (!response.ok) {
      try {
        const data = await response.clone().json();
        const message = data.errors?.[0] ?? 'An error occurred';
        toast.error(message);
      } catch {
        toast.error('An error occurred');
      }
    }

    return response;
  } catch (err) {
    toast.error('Network error');
    throw err;
  }
}

export async function fetchWithoutAuth(input: RequestInfo, init: RequestInit = {}) {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}${input}`, {
      ...init,
      headers: {
        'Content-Type': 'application/json',
        ...(init.headers || {}),
        "ngrok-skip-browser-warning": "monkey"
      },
    });

    if (!response.ok) {
      try {
        const data = await response.clone().json();
        const message = data.errors?.[0] ?? 'An error occurred';
        toast.error(message);
      } catch {
        toast.error('An error occurred');
      }
    }

    return response;
  } catch (err) {
    toast.error('Network error');
    throw err;
  }
}
